import React, { useState } from "react";

export default function BankForm({
  initialData,
  onSave,
  onCancel,
}) {
  const [form, setForm] = useState(
    initialData || {
      bank_name: "",
      account_number: "",
      ifsc: "",
      is_default: false,
    }
  );

  return (
    <div
      style={{
        border: "1px solid #e5e7eb",
        borderRadius: 8,
        padding: 16,
        marginBottom: 16,
        background: "#f9fafb",
      }}
    >
      <div className="erp-form-grid">
        <div className="erp-field">
          <label>Bank Name</label>
          <input
            value={form.bank_name}
            onChange={(e) =>
              setForm({
                ...form,
                bank_name: e.target.value,
              })
            }
          />
        </div>

        <div className="erp-field">
          <label>Account Number</label>
          <input
            value={form.account_number}
            onChange={(e) =>
              setForm({
                ...form,
                account_number: e.target.value,
              })
            }
          />
        </div>

        <div className="erp-field">
          <label>IFSC Code</label>
          <input
            value={form.ifsc}
            onChange={(e) =>
              setForm({
                ...form,
                ifsc: e.target.value,
              })
            }
          />
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            marginTop: 24,
          }}
        >
          <input
            type="checkbox"
            checked={form.is_default}
            onChange={(e) =>
              setForm({
                ...form,
                is_default: e.target.checked,
              })
            }
          />
          Default Bank Account
        </div>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: 10,
          marginTop: 16,
        }}
      >
        <button
          className="btn btn-secondary"
          onClick={onCancel}
        >
          Cancel
        </button>

        <button
          className="btn btn-primary"
          onClick={() => onSave(form)}
        >
          Save Bank
        </button>
      </div>
    </div>
  );
}
